// extracted by mini-css-extract-plugin
module.exports = {"cardWidth":"RTUData_cardWidth__yqq09","towerIcon":"RTUData_towerIcon__35mJr","serialData":"RTUData_serialData__2l2CE"};